import { BatchRender } from "./BatchRender";
export class StatiVertexMergeBatchRender extends BatchRender {
    _addList(renderNodes) {
    }
}
